import { createSlice } from "@reduxjs/toolkit";

export const practiceSet = createSlice({
  name: "practiceSet",
  initialState: {
    correct: 0,
    incorrect: 0,
    correctIndexList: [],
    incorrectIndexList: [],
    selectedQuestion: 0,
    practiceSetId: "",
    questions: [],
    markedList: [],
  },
  reducers: {
    setCorrectCount: (state, action) => {
      state.correct = action.payload;
    },
    setInCorrectCount: (state, action) => {
      state.incorrect = action.payload;
    },
    setCorrectIndexList: (state, action) => {
      state.correctIndexList = [...action.payload];
    },
    setInCorrectIndexList: (state, action) => {
      state.incorrectIndexList = [...action.payload];
    },
    setSelectedQuestions: (state, action) => {
      state.selectedQuestion = action.payload;
    },
    setPracticeSetId: (state, action) => {
      state.practiceSetId = action.payload;
    },
    setQuestions: (state, action) => {
      state.questions = [...action.payload];
    },
    setMarkedList: (state, action) => {
      state.markedList = [...action.payload];
    },
    clearAll: (state) => {
      state.correct = 0;
      state.incorrect = 0;
      state.incorrectIndexList = [];
      state.correctIndexList = [];
      state.selectedQuestion = 0;
      state.practiceSetId = "";
      state.questions = [];
      state.markedList = [];
    },
  },
});

// this is for dispatch
export const {
  setCorrectCount,
  setCorrectIndexList,
  setInCorrectCount,
  setInCorrectIndexList,
  setPracticeSetId,
  setSelectedQuestions,
  setQuestions,
  setMarkedList,
  clearAll,
} = practiceSet.actions;

// this is for configureStore
export default practiceSet.reducer;
